import type { ComponentType } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import {
  ThumbUp,
  ThumbDown,
  ThumbUpOutlined,
  ThumbDownOutlined,
} from "@mui/icons-material";
import { ReactionKind } from "@/constants/reaction-kind";
import { useArticleReactions } from "@/hooks/useArticleReactions";

function ReactionCount({
  active,
  count,
  onClick,
  FilledIcon,
  OutlinedIcon,
}: {
  active: boolean;
  count: number;
  onClick: () => void;
  FilledIcon: ComponentType<SvgIconProps>;
  OutlinedIcon: ComponentType<SvgIconProps>;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <IconButton
        size="small"
        onClick={onClick}
        color={active ? "primary" : "default"}
      >
        {active ? (
          <FilledIcon fontSize="small" />
        ) : (
          <OutlinedIcon fontSize="small" />
        )}
      </IconButton>
      <Typography variant="body2">{count}</Typography>
    </Box>
  );
}

export function ReactionBar({ articleId }: { articleId: string }) {
  const { summary, userReaction, toggleReaction } =
    useArticleReactions(articleId);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 2 }}>
      <ReactionCount
        active={userReaction === ReactionKind.ThumbsUp}
        count={summary.thumbsUp}
        onClick={() => toggleReaction(ReactionKind.ThumbsUp)}
        FilledIcon={ThumbUp}
        OutlinedIcon={ThumbUpOutlined}
      />
      <ReactionCount
        active={userReaction === ReactionKind.ThumbsDown}
        count={summary.thumbsDown}
        onClick={() => toggleReaction(ReactionKind.ThumbsDown)}
        FilledIcon={ThumbDown}
        OutlinedIcon={ThumbDownOutlined}
      />
    </Box>
  );
}
